import {all, fork, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import {onInit} from "./sagas/onInit";
import {onUpdateFormItems} from "./sagas/onUpdateFormItems";
import {onRequestDataForItemModal} from "./sagas/onRequestDataForItemModal";

function* onStartListener() {
    yield takeEvery(actions.TXN_TRANSFER_INIT, onInit);
}

function* onRequestDataForItemModalListener() {
    yield takeEvery([
        actions.TXN_TRANSFER_OPEN_ITEM_MODAL,
        actions.TXN_TRANSFER_CHANGE_SELECTED_TRANSACTION_IDS,
    ], onRequestDataForItemModal);
}

function* onSelectionsChangeListener() {
    yield takeEvery([
        actions.TXN_TRANSFER_CLOSE_ITEM_MODAL,
    ], onUpdateFormItems);
}

export default function* rootSaga() {
    yield all([
        fork(onStartListener),
        fork(onRequestDataForItemModalListener),
        fork(onSelectionsChangeListener),
    ]);
}
